import { render, staticRenderFns } from "./UsuarioFormModal.vue?vue&type=template&id=0a1f85b3"
import script from "./UsuarioFormModal.vue?vue&type=script&lang=js"
export * from "./UsuarioFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports